module.exports = __webpack_public_path__ + "img/rightArrow.7a75812e.svg";